import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const normalityTool: Tool = {
  id: "normality",
  name: () => m.norm_tool_name(),
  description: () => m.norm_tool_description(),
  icon: "⚖️",
  basePath: "/normality",
  status: "stable",
  tags: ["calculator", "chemistry", "science", "lab", "normality", "titration"],
};
